import * as React from "react";
import { padLeft } from "~/utils/string-utils";
import VideoPlayer, { VideoPlayerProps } from "../video-player/video-player";
import Icon from "../icons/icon";
import ContentSection from "../content-section/content-section";

export interface VideoProps extends VideoPlayerProps {
    title?: string;
    hideDuration?: boolean;
    hidePlayButton?: boolean;
    hasNoMarginTop?: boolean;
    hasNoMarginBottom?: boolean;
    anchorId?: string;
}

const Video = ({ url, autoPlay, playerId, hideDuration, hidePlayButton, title, ...props }: VideoProps) => {
    const baseClass = "video";

    const [duration, setDuration] = React.useState<number | undefined>();
    const [isPlaying, setIsPlaying] = React.useState(false);

    const formattedDuration = React.useMemo(() => {
        const d = duration || 0;
        const minutes = Math.floor(d / 60);
        const seconds = d % 60;

        return `${minutes}:${padLeft(seconds.toString(), 2, "0")}`;
    }, [duration]);

    const toggleIsPlaying = () => {
        setIsPlaying(!isPlaying);
    };

    return (
        <ContentSection className={baseClass} {...props}>
            <div className={`${baseClass}__inner`}>
                <div className={`${baseClass}__meta-wrapper`}>
                    {title && <h3 className={`${baseClass}__title h3-style`}>{title}</h3>}
                    {!hideDuration && duration && (
                        <div className={`${baseClass}__duration`}>{formattedDuration}</div>
                    )}
                </div>

                <VideoPlayer
                    url={url}
                    playerId={playerId}
                    autoPlay={autoPlay}
                    hideNativePlayBtn={!hidePlayButton}
                    setDuration={setDuration}
                    setIsPlaying={setIsPlaying}
                    isPlaying={isPlaying}
                />
                {!hidePlayButton && (
                    <div className={`${baseClass}__button-wrapper`}>
                        <button
                            className={`${baseClass}__button ${
                                isPlaying ? `${baseClass}__button--playing` : ""
                            }`}
                            onClick={toggleIsPlaying}
                        >
                            <Icon iconId="24_play" />
                        </button>
                    </div>
                )}
            </div>
        </ContentSection>
    );
};

export default Video;
